import { createContext } from 'react';
import { TemplateModalContextProps } from './TemplateModal.types';

const TemplateModalContext =
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  createContext<TemplateModalContextProps>(undefined);

export default TemplateModalContext;
